import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import avatar from "../assets/images/Picsart_24-06-05_22-02-59-622.jpg";
import '../assets/styles/Main.scss';

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Shuvambhagat" target="_blank" rel="noreferrer">
              <GitHubIcon />
            </a>
            <a href="https://www.linkedin.com/in/shuvam-bhagat-10a361214/" target="_blank" rel="noreferrer">
              <LinkedInIcon />
            </a>
            <a href="https://www.instagram.com/YOUR_INSTAGRAM" target="_blank" rel="noreferrer">
              <InstagramIcon />
            </a>
          </div>
          <h1>Shuvam Bhagat</h1>
          <p>Full Stack Engineer | Data Analyst | AI Enthusiast</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Shuvambhagat" target="_blank" rel="noreferrer">
              <GitHubIcon />
            </a>
            <a href="https://www.linkedin.com/in/shuvam-bhagat-10a361214/" target="_blank" rel="noreferrer">
              <LinkedInIcon />
            </a>
            <a href="https://www.instagram.com/YOUR_INSTAGRAM" target="_blank" rel="noreferrer">
              <InstagramIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
